import React from 'react';

class LoadMore extends React.Component {
  constructor() {
    super(...arguments);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (!this.props.loading) {
      this.props.onClick();
    }
  }

  render() {
    return (
      <div
        ref="wrapper"
        className={this.props.className || 'col-md-12'}
        style={{textAlign: 'center'}}
      >
        <span className="btn btn-default" onClick={this.onClick}>
          {this.props.loading ? (
            <span>
              <span className="public-loader"></span>{' '}
              <span className="loading-text">Loading...</span>
            </span>
          ) : (
            'Load More'
          )}
        </span>
      </div>
    );
  }
}

export default LoadMore;
